
































































import { Component, Vue, Prop } from 'vue-property-decorator'
import CustomForm from '@/components/custom-form/index.vue'
import AbpBase from '@/lib/abpbase'
import CustomTableApi from '@/api/customTable/index'
@Component({
  components: {
    CustomForm,
  },
})
export default class CustomTable extends AbpBase {
  @Prop({
    type: Boolean,
    default: true,
  })
  showBtn!: boolean
  @Prop({
    type: Boolean,
    default: true,
  })
  isShowPage!: boolean
  @Prop({
    type: Boolean,
    default: false,
  })
  isChecked!: boolean
  @Prop({
    type: Boolean,
    default: true,
  })
  isMultiple!: boolean
  @Prop({
    type: String,
    default: '选择店铺',
  })
  btnText!: string
  @Prop({
    type: Array,
    default: () => [],
  })
  columns!: []
  @Prop({
    type: Array,
    default: () => [],
  })
  filters!: []
  @Prop({
    type: String,
    default: '',
  })
  customTableTitle!: string
  @Prop({
    type: String,
    default: '',
  })
  tableApi!: string
  @Prop({
    type: Array,
    default: () => []
  })
  selectedItems!: []
  loading: boolean = false
  isCheckAll: boolean = false
  data: any[] = []
  selectedIds: any = new Set()
  openCustomTabel: boolean = false
  page: any = {
    maxResultCount: 10,
    currentPage: 1,
    totalCount: 0,
  }
  handleClickSelect() {
    this.openCustomTabel = true
    this.submitFn()
  }
  onSubmit(form) {
    this.getDataList(form)
  }
  handleQuery() {
    this.page.currentPage = 1
    this.submitFn()
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    console.log(form)
    form.submit()
  }
  getDataList(form?) {
    let { page } = this
    this.loading = true
    this.isCheckAll = false
    let copyForm: any = {}
    // let orderNo = form ? form['orderNo'] : null
    // let shippingInfo = form ? form['shippingInfo'] : null
    console.log('test', form)
    // let date = form ? this.dateString(form['date']) : null
    // let begin = form ? this.dateString(form['date'][0]) : null
    // let end = form ? this.dateString(form['date'][1]) : null
    if(form.dateTimeRange) {
      copyForm.BeginTime = this.dateString(form['dateTimeRange'][0])
      copyForm.EndTime = this.dateString(form['dateTimeRange'][1])
      copyForm = {...copyForm, ...form}
      delete copyForm.dateTimeRange
    }else {
      copyForm = { ...form }
    }

    CustomTableApi.getDataList(this.tableApi, page.currentPage, page.maxResultCount, copyForm)
      .then((res) => {
        this.loading = false
        let result = []
        res.data.items.forEach((element) => {
          if(this.isChecked) {
            element['_checked'] = this.selectedItems.findIndex((x) => x == element.id) > -1
          }else {
            element['_disabled'] = this.selectedItems.findIndex((x) => x == element.id) > -1
          }
          result.push(element)
        })
        this.data = result
        page.totalCount = res.data.totalCount
      })
      .catch((err) => {
        this.loading = false
      })
  }
  pageSizeChange(e) {
    this.page.maxResultCount = e
    this.page.currentPage = 1
    this.submitFn()
  }
  changePage(e) {
    this.page.currentPage = e
    this.submitFn()
  }
  sure() {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      console.log(selection);
      this.openCustomTabel = false
      this.$emit('on-select-row', selection)  
    } else {
      this.$Notice.warning({
        title: '请先选择数据',
      })
    }
  }
  handleTableAllCancel() {
    this.isCheckAll = false
    let data = (this.$refs.selection as any).data
    data.forEach((item) => {
      if (this.selectedIds.has(item.id)) {
        this.selectedIds.delete(item.id)
      }
    })
  }

  handleTableAll(selection) {
    this.isCheckAll = true
    selection.forEach((item) => {
      this.selectedIds.add(item.id)
    })
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.data.length
  }

  handleSelect(slection, row) {
    this.selectedIds.add(row.id)
  }
  handleCancel(slection, row) {
    this.selectedIds.delete(row.id)
  }
  handleClickRow(row) {
    if(!this.isMultiple) {
      this.$emit('clickRowItem', row)
      this.openCustomTabel = false
    }
  }
}
